import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { Container } from '@material-ui/core';

type Props = {
  open: boolean;
  onClose: () => void;
};

const ModalPopupBloqueado: React.FC<Props> = ({ open, onClose }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="popup-bloqueado-title"
      aria-describedby="popup-bloqueado-description"
      PaperProps={{
        style: {
          borderRadius: 20,
          backgroundColor: '#fff',
          boxShadow: '0px 8px 16px rgba(0, 0, 0, 0.1)'
        }
      }}
    >
      <Container style={{ padding: '20px' }}>
        <DialogTitle id="popup-bloqueado-title" style={{ textAlign: 'center' }}>
          Pop-up bloqueado
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="popup-bloqueado-description"
            style={{ color: 'black', textAlign: 'center' }}
          >
            O pop-up foi bloqueado pelo navegador. Libere os pop-ups deste site e tente novamente.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center' }}>
          <Button onClick={onClose} color="primary" variant="contained" autoFocus>
            Entendi
          </Button>
        </DialogActions>
      </Container>
    </Dialog>
  );
};

export default ModalPopupBloqueado;
